import axios from 'axios';

import {
  setAlertWithTitle,
  setSessionExpired,
  setSpinnerLoading,
} from '../../../utility/Redux/modal';
import { CallAPIPromise } from '../../menu/dashboard/biiling/modal/comman';

export const GetItemSummary = async (
  setItemList,
  prefix,
  token,
  dispatch,
  fromDate,
  toDate,
  section
) => {
  dispatch(setSpinnerLoading('Loading Item Summary'));
  const data = {
    table_prefix: prefix,
    FDATE: fromDate,
    TDATE: toDate,
    SECTION_NAME: section,
  };
  CallAPIPromise('/api/saveInHouseMfg/itemWiseMfg', data, token, dispatch)
    .then((p) => {
      if (!p.data.error) {
        const data = p.data.response;
        let rowList = [];

        for (let index = 0; index < data.length; index++) {
          rowList.push({
            ...data[index],
            id: index + 1,
          });
        }
        setItemList(rowList);
      } else {
        dispatch(
          setAlertWithTitle({
            title: 'Error',
            msg: 'Something went wrong',
          })
        );
      }
    })
    .catch((error) => {
      console.log(error);
      if (error.response.data.name === 'TokenExpiredError') {
        dispatch(setSessionExpired(true));
      } else {
        dispatch(
          setAlertWithTitle({
            title: 'Error',
            msg: 'Something went wrong',
          })
        );
      }
    })
    .finally(() => {
      dispatch(setSpinnerLoading(false));
    });
};
